<template>
  <div class="details">
    <van-nav-bar
      class="navt"
      title="修改订单"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="dnum">
      <span>订单号：</span> {{$route.params.id.order_id}}
    </div>
    <div class="">
      <img
        src="../../assets/bottom-bj.jpg"
        alt=""
      ></div>
    <div v-show='yshow' class="address">
      <p class="top"><span class="name">{{$route.params.id.realname}}</span><span style="float:right">{{$route.params.id.mobile}}</span></p>
      <p class="bottom">{{$route.params.id.prov+$route.params.id.city+$route.params.id.dist+$route.params.id.address_detail}}</p>
      <div class="more">

      </div>

    </div>
    <div v-show='!yshow' class="address">
      <p class="top"><span class="name">{{address.name}}</span><span style="float:right">{{address.mobile}}</span></p>
      <p class="bottom">{{address.address}}</p>
      <div class="more">
      </div>
    </div>
    <div class="">
      <img
        src="../../assets/bottom-bj.jpg"
        alt=""
      ></div>
    <div class="datails">
      <div class="shop">{{$route.params.id.store_name}}</div>
      <div class="top">
        <div
          class="card "
          v-for="(v,i) in $route.params.id.goods"
          :key="i"
          @click="go(v)"
        >
        <van-swipe-cell>
          <van-card>
            <template #thumb>
              <img
                class="imgs"
                :src="v.sku_thumb"
                alt=""
              >
            </template>
            <template #title>
              <div class="title">{{v.name}}</div>
            </template>
            <template #price>
              <div class="price">￥{{v.goods_price}}</div>
            </template>
            
          </van-card>
          <div class="close">

           <van-stepper
                      :disabled='v.ishuodong==1 || v.zengpin==1'
                      input-width="1.5rem"
                      button-size="0.75rem"
                      class="stepper"
                      @change="onChange(v)"
                      v-model="v.goods_num"
                      :max="v.sku_stock"
                    />
          </div>
          <template #right>
                  <van-button
                    square
                 
                    text="删除"
                    type="danger"
                    class="delete-button"
                    @click="delete_shop(v)"
                  />
                </template>
        </van-swipe-cell>
        </div>

        <!-- <div class="num">
          <p>是否开具发票</p>
          <span>{{$route.params.id.is_bill}}</span>
          <div class="more">

          </div>
        </div> -->
        <div class="v_field">
          <p>买家留言：</p>

          <textarea
            v-model="wb"
            class="field"
            maxlength=45
            placeholder="选填：留言请在45字之内"
          ></textarea>
        </div>
        <div class="prices">
          <div class="p_num"> 共计：<span>{{$route.params.id.goods.length}}</span>件商品</div>
        </div>
        <div class="statistics">
          <!-- <div class="num">
            <p>商品总额</p>
            <span>￥{{$route.params.id.total_price}} </span>
          </div> -->
          <div class="num">
            <p>运费</p>
            <span>+ ￥{{$route.params.id.freight}} </span>
          </div>
          <div class="num">
            <p>优惠劵</p>
            <span>- ￥{{$route.params.id.money}} </span>
          </div>
          <div class="num">
            <p>实际付款</p>
            <span>￥{{actual_money1}} </span>
          </div>
          <hr>
          <div class="dnum">
            <span>下单时间 ： </span>{{$route.params.id.addtime}}
          </div>
        </div>

      </div>
      <div class="buts">

        <div class="but">
            
         
          <van-button
            type="danger"
            size="small"
            class="v_but"
            @click="buy"
           
          >提交结算</van-button>
       
          <van-button
           style="width:33%"
            color="#666"
            size="small"
            class="v_but"
            @click="ash"

          >修改收货地址</van-button>
          
        </div>
      </div>
    </div>
     <van-popup
      v-model="show"
      position="bottom"
      style="height: 80%; padding-top: 4px;"
    >
    <div class="red">*修改订单中不能新增修改地址，请先在我的收货地址中编辑</div>
       <van-address-list
      v-model="chosenAddressId"
      :list="list"
      add-button-text="确认"
      address-list-edit-icon-size="0px"
      @add='add'
    />
      
    </van-popup>
    <van-dialog v-model="show2" title="" show-cancel-button>
  <p class="fp fp1">当前该订单已经进入发货排期队列，</p>
  <p class="fp">无法被直接取消或修改，</p>
  <p class="fp">若您坚持要取消或修改此笔交易的，</p>
  <p class="fp">请联系客服人员或专属业务经理在后台予以实现</p>
  <p class="fp">客服电话 {{sn}}</p>
  <p class="fp">业务经理 {{yt }} {{yn}}</p>
</van-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  NavBar,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Toast,
  Icon,
  Card, Stepper, Button, Field, Popup, Dialog,SwipeCell,AddressList
} from 'vant'

Vue.use(NavBar)
  .use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Toast).use(Icon)
  .use(Card)
  .use(Stepper)
  .use(Button).use(Field).use(Popup).use(Dialog).use(SwipeCell).use(AddressList)
export default {
  created () {
    // this.actual_money=this.$route.params.id.actual_money
    if(this.$route.params.id){}else{
      this.$router.push('/my')
    }
    this.total_price=this.$route.params.id.total_price
    this.wb=this.$route.params.id.remark
    this.buy_goods=this.$route.params.id.goods
    this.$route.params.id.goods.forEach(v => {
      this.txt += v.goods_num
    })
    this.axios.post('getSalesMobileAndName', {  }).then(res => {        
        console.log(res)   
        this.yt=res.data.data.sales_name
        this.yn=res.data.data.sales_mobile

        this.sn=res.data.data.store_mobile
      
      }).catch(ref => { })
    this.axios.get('listAddress').then(res => {
       
        if (res.data.code == 200) {

          res.data.data.forEach(v => {
            // console.log(v)
            let obj = {}
            obj.name = v.realname
            obj.areaCode = v.areaCode + ''
            obj.tel = v.mobile
            obj.id = v.id
            obj.province = v.prov
            obj.city = v.city
            obj.county = v.dist
            obj.addressDetail = v.address_detail
            obj.address = v.prov + v.city + v.dist + v.address_detail
            obj.isDefault = v.is_default ? true : false
            // console.log(obj)
            this.list.push(obj)
          });
        }
      }).catch(ref => {
        console.log(ref)
      })
    // console.log(this.$route.params.id.goods)
  },

  data () {
    return {
      address: { name: 'name', address: "address", tel: "mobile" },
      txt: 0,
      mobile: "",
      total_price:0,
      show:false,
      buy_goods:[],
      list:[],
      chosenAddressId:0,
      yshow:true,
      wb:'',
      show2:false,
      sn:'',
      yn:'',
      yt:'',
    }
  },
    computed: {
   actual_money1() {
      let money = 0
    //   console.log(this.buy_goods)
      this.buy_goods.forEach((v) => {
        if(v.keel==1){
        money += v.goods_price * v.goods_num*v.meter
      }else{
        money += v.goods_price * v.goods_num

      }
      })
      return (money+Number(this.$route.params.id.freight)-Number(this.$route.params.id.money) ).toFixed(2)
    },
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onChange(){

    },
    buy () {
      console.log(this.buy_goods)
       this.axios.post('modifyGoods', { order_id:this.$route.params.id.id ,goods:this.buy_goods,money:this.actual_money1,remarks:this.wb }).then(res => {
        console.log(res)
        if (res.data.code == 200) {
         
        }else{
          
        }
        })
      return
      this.$router.push({ name: 'cashier', query: { money: this.$route.params.id.actual_money, sid: this.$route.params.id.store_id,order:this.$route.params.id.id } })
    },
    go (v) {
      // console.log(this.$route.params.id.changjia)
      // return
      // if (this.$route.params.id.changjia == 1) {
      //   this.$router.push({ name: 'product', query: { id: v.goods_id, from: 1, c: 1 } })
      // } else {
      //   this.$router.push({ name: 'product', query: { id: v.goods_id, from: 1 } })
      // }
    },
    ash () {
     this.show=true
    },
    add(){
      console.log(this.list)
      this.list.forEach(v=>{
        if(v.id==this.chosenAddressId){
          this.show=false
          
          this.axios.post('modifyAddress', { address_id: v.id,order_id:this.$route.params.id.id  }).then(res => {
        if (res.data.code == 200) {
          this.address={name:v.name,tel:v.tel,address:v.address}
          this.yshow=false
         Toast('修改成功')
        }else{
          this.show2=true
        }
        // console.log(res)
        // Toast(res.data.msg)
        
      }).catch(ref => { })
        }
      })
    },
    delete_shop(v){
        console.log(v)
        
        
        let s=''
        this.buy_goods.forEach((a,i)=>{
            if(a.order_goods_id==v.order_goods_id){
                s=i
                this.axios.post('deleteGoodsDetail', { order_goods_id: v.order_goods_id,order_id:this.$route.params.id.id  }).then(res => {
        if (res.data.code == 200) {
          this.buy_goods.splice(s,1)
         Toast('修改成功')
        }else{
          this.show2=true 
        }
        }).catch(ref=>{})
            }
            })

        console.log(s)
       
    },
    delet () {
      Dialog.confirm({
        title: '是否删除取消订单',
        message: '',
      }).then(() => {
        this.axios.post('del_order', { id: this.$route.params.id.id }).then(res => {
          if (res.data.code == 1004) {
            localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
            this.delet()
          }
          // console.log(res)
          Toast(res.data.msg)
          this.$router.go(-1)
          done()
        }).catch(ref => { })
      }).catch(() => { })
    },
    back () {

      this.axios.post('goods_back', { store_id: this.$route.params.id.store_id }).then(res => {
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.back()
        }
        // console.log(res)
        // Toast(res.data.msg)
        Dialog.confirm({
          title: '请联系业务员退货',
          message: res.data.data.mobile,
          confirmButtonText: '呼叫'
        }).then(() => {
          window.location.href = "tel:" + res.data.data.mobile
        }).catch(ref => { })
      }).catch(ref => { })

    }
  }
}
</script>
<style lang="less" scoped>
.van-address-item__edit{
  top:-50%
}
.delete-button{
    height: 100%;
}
.red{
  color: rgb(248, 58, 58);
  text-align: center;
  line-height: 1rem;
}
.details {
  padding-top: 1.2rem;
  background-color: #f1f1f1;
}
.navt {
  width: 100%;
  position: fixed;
  top: 0;
}
.fp{
  line-height: 0.6rem;
  text-align: center;
  font-size: 0.38rem;
}
.fp1{
  padding-top: 0.5rem;
}
.address {
  position: relative;
  padding: 0.4rem;
  width: 100%;
  height: 2rem;
  background-color: #fefcee;
  .top {
    height: 0.76rem;
    .name {
      padding-right: 2rem;
      font-size: 0.426667rem;
    }
  }
  .bottom {
    font-size: 0.373333rem;
    color: #888;
  }
}
.cs {
  text-align: center;
  line-height: 1.3rem;
  color: red;
}
.dnum {
  font-size: 0.4rem;
  background-color: #fff;
  line-height: 0.8rem;
  padding-left: 0.3rem;
  span {
    color: #666;
  }
}
.datails {
  margin-top: 0.266667rem;
  background-color: #fff;
  .shop {
    padding: 0.426667rem;
    color: #a22d2b;
    font-size: 0.426667rem;
    border-bottom: 0.03rem solid #dfdfdd;
  }
  .top {
    position: relative;
    background-color: #fff;
    width: 100%;
    padding-bottom: 2.3rem;
    .card {
      border-bottom: 0.03rem solid #dfdfdd;
      .van-card {
        background-color: #fff;
        padding-bottom: 0;
      }

      width: 100%;
      position: relative;
      padding-top: 0.2rem;
    }
    .title {
      padding-top: 0.2rem;
      font-size: 0.34rem;
    }
    .imgs {
      width: 2rem;
      height: 2rem;
    }
    .price {
      color: #e02828;

      font-size: 0.5rem;
      padding-bottom: 0.64rem;
    }
    .close {
      text-align: right;
      font-size: 0.4rem;
      // color: #d3d;
      position: absolute;
      right: 5%;
      top: 60%;
      background-color: #fff;
    }

    .num {
      border-bottom: 0.03rem solid #dfdfdd;
      color: #757575;
      padding: 0.3rem 0.35rem;
      display: flex;
      position: relative;
      span {
        text-align: right;
        width: 4rem;
        overflow: hidden; /*超过部分不显示*/
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 0.85rem;
        font-size: 0.35rem;
        padding-right: 10%;
      }
      p {
        line-height: 0.85rem;
        font-size: 0.35rem;
        flex: 1;
      }
      .stepper {
        flex: 1;
        text-align: right;
      }
    }
    .v_field {
      border-bottom: 0.03rem solid #dfdfdd;
      color: #757575;
      padding: 0.3rem 0.35rem;
      p {
        line-height: 0.85rem;
        font-size: 0.35rem;
      }
      .field {
        background-color: #f1f1f1;
        width: 100%;
        border: none;
        height: 1.2rem;
        text-indent: 0.2rem;
        resize: none;
        padding-top: 0.2rem;
      }
    }
    .prices {
      padding: 0.35rem 0.5rem;
      text-align: right;
      .p_num {
        // font-size: 0.4rem;
        color: #666;
        span {
          // font-size: 0.48rem;
          color: #a22d28;
          // padding-right: 0.5rem;
        }
      }
    }
  }
  .statistics {
    background-color: #dfdfdf;
    // margin-top: 1rem;
    height: 3.5rem;
    width: 100%;
    padding-top: 0.2rem;
    .num {
      border: none;
      padding: 0 0 0 0.3rem;
      background-color: #fff;
      span {
        color: #d0111b;
      }
    }
  }
  .buts {
    width: 100%;
    position: fixed;
    bottom: 0;
    border-top: 0.03rem solid #dfdfdf;
    background-color: #fff;
  }
  .but {
    display: flex;
    flex-direction: row-reverse;
    .v_but {
      width: 25%;
      margin: 0.2rem;
    }
  }
}
</style>